export default {
  subtitle: "Credit card transactions Brazil - JWT for DDC",
  path: "transaction_3ds_cc_br_jwt_for_ddc",
  paragraphs: [
    'Generates a new JWT to be used in DDC (Device Data Collection) step. This token is required, otherwise, the DDC step will fail.',
    'The DDC step is performed on the shopper\'s browser to collect device data as part of the authentication process. After the DDC step is done, it returns a `SessionId`, which will be sent as `df_reference_id` in the payment request.',
    'For a practical example of how the DDC step is implemented, refer to the provided sample checkout page (See "Credit card transactions Brazil" section). This sample demonstrates the process of obtaining the JWT from the `/acquirer_v2/ddc/token/` endpoint, passing it to the frontend (via `facilitapay.setJwtForDdc(jwt)`), and performing device data collection in the shopper’s browser. Reviewing this HTML sample will help clarify how to integrate the DDC flow into your own checkout page.'
  ],
  request: {
    method: "GET",
    endpoint: "/acquirer_v2/ddc/token",
    responses: {"data": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..."}
  },
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/CreditCardBRJWTForDDC.js